// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"3d19a1c9","69":"f201c746","208":"6357ff3c","223":"e89029a9","338":"6e74ab17","405":"1d1436b5","496":"875e8ce0","595":"b53a8866","936":"241b11eb","971":"f544d973"}[chunkId] + ".chunk.js";
};